
export default {
    state: {
        colorPicker: {
            captiveStyleId: undefined,
            active: false,
            type: undefined,
            color: {
                r: undefined,
                g: undefined,
                b: undefined,
                a: undefined,
            },
        },
    },    

    mutations: {   
        SET_COLOR_PICKER_STATE_CAPTIVE_STYLE(state, { active, captiveStyleId, type }) {
            state.colorPicker.active = active;
            state.colorPicker.captiveStyleId = captiveStyleId;
            state.colorPicker.type = type;
        },
        SET_COLOR_PICKER_VAL_CAPTIVE_STYLE(state, val) {
            state.colorPicker.color = val;
        },        
    }
};
